"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import _get from 'lodash/get';
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var createdDate = value;
    var formatedDate = (0, _moment["default"])(createdDate).format('MM-DD-YYYY');
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: "".concat(_style["default"].createdDateContainer, " text-center")
    }, formatedDate);
  };
};